module.exports = __webpack_public_path__ + "static/hospital-7ac0a0f65e56d520be0ad0e7eb56a760.jpg";